import apiClient, { unwrap } from './client';
import type {
  ApiEnvelope,
  ClientOption,
  ClientRecord,
  CreateClientInput,
} from '@types';

export const clientsApi = {
  /** All clients, for the document-list filter + editor picker (F2.1). */
  list: async (): Promise<ClientOption[]> => {
    const envelope =
      await apiClient.get<ApiEnvelope<ClientOption[]>>('/v1/clients');
    return unwrap(envelope);
  },

  /** Inline client creation from the editor (F2.2). */
  create: async (input: CreateClientInput): Promise<ClientRecord> => {
    const envelope = await apiClient.post<ApiEnvelope<ClientRecord>>(
      '/v1/clients',
      input
    );
    return unwrap(envelope);
  },
};

export default clientsApi;
